import $http from '$http'
import { util } from 'utils';
import { lg } from 'utils';

export default {
    methods: {
        AddMeetAgent(data) {
            //POST /api/Agent/PassAgent
            //PassAgentEx 2017/10/23新增金蝶编码字段
            this.submiting = true;
            $http.post('api/Agent/AddMeetAgent', data).then(res => {
                util.doResult(this, res, () => {
                    let { Data, Cnt } = res.data;
                    this.$notify({
                        title: '成功',
                        message: '添加成功！',
                        type: 'success'
                    });
                    this.submiting = false;
                    this.$emit('reload-list');
                    this.$emit('agentList',Data);
                    this.$store.dispatch("getAgentList");//获取幼儿园管理中的代理商管理
                    this.close();
                }, () => {
                    this.submiting = false;
                });
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/common/components/agent-add/services.js